import React, { ReactNode } from "react";
import {
  EmptyStateContainer,
  CustomHeading,
  EmptyStateIconContainer,
  EmptyStateChildren,
} from "./style";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, children }) => {
  return (
    <EmptyStateContainer>
      <EmptyStateIconContainer>{icon}</EmptyStateIconContainer>
      <CustomHeading element="h3" size="xs" margin="xs">
        {title}
      </CustomHeading>
      {children && <EmptyStateChildren>{children}</EmptyStateChildren>}
    </EmptyStateContainer>
  );
};

export default EmptyState;
